import { InjectionToken } from '@angular/core';
import type { ArrowLoginSignupMarketingConfig } from './arrow-login-signup-marketing.interface';

export const ARROW_LOGIN_SIGNUP_MARKETING_CONFIG = new InjectionToken<ArrowLoginSignupMarketingConfig>(
  'ArrowLoginSignupMarketingConfig',
);
